module.exports = __webpack_public_path__ + "static/giant_fire_bittle-9c233c2122ecb33eaa854d5ae5b507f3.jpeg";